module.exports = __webpack_public_path__ + "static/media/ucm_logo.01c23e23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/integrations_logos/ucm_logo.svg
// module id = 305
// module chunks = 0